import React from 'react';

const bgColorMap = {
  green: 'bg-primary-100 text-primary',
  amber: 'bg-amber-50 text-amber',
  blue: 'bg-blue-50 text-blue-600',
  red: 'bg-error-50 text-error',
};

const ReporterStatCard = ({ icon: Icon, label, value, color = 'green', subtitle }) => {
  return (
    <div className="group rounded-3xl border border-char-100 bg-white p-5 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-card-hover sm:p-6">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-char-400">
            {label}
          </p>
          <p className="text-3xl font-extrabold text-char-900">{value}</p>
        </div>
        <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${bgColorMap[color]}`}>
          <Icon size={20} />
        </div>
      </div>
      {subtitle && (
        <p className="mt-2 text-xs text-char-400">{subtitle}</p>
      )}
    </div>
  );
};

export default ReporterStatCard;
